import { Component } from "react";
import { Button, Typography, Box } from "@mui/material";
import { styled } from "@mui/material/styles";

const ErrorContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  textAlign: "center",
  maxWidth: 600,
  margin: "0 auto",
  marginTop: theme.spacing(8),
}));

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error caught by boundary:", error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <ErrorContainer>
          <Typography variant="h5" gutterBottom>
            出現了一些問題
          </Typography>
          <Typography color="textSecondary" paragraph>
            {this.state.error?.message || "發生未知錯誤"}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={this.handleReset}
          >
            重新整理頁面
          </Button>
        </ErrorContainer>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
